import { Rule } from '@mui/icons-material';
import { useEffect } from 'react';
import { navigateTo } from '@/utils/navigation';
import { NeedsAttentionCard } from '@/views/Home/components/NeedsAttention/components/NeedsAttentionCard';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';
import type { AuditRequest } from '$api-clients/hooks';

type Props = {
  interactionCount: number;
  audits: AuditRequest<'/audits/'>['Data']['results'];
};

export function ComplianceReviewIncomplete({
  audits,
  interactionCount,
}: Props) {
  const trackEvent = useTrackHomePageAnalytics();

  const supplementaryDetails: string[] = [];
  if (interactionCount > 0) {
    supplementaryDetails.push(`Audits that have rejected documents`);
  }

  const handleClick = () => {
    trackEvent(TrackHomePageEvent.NeedsAttentionCardClick, {
      numItem: interactionCount,
      eventTarget: 'compliance',
    });

    if (interactionCount > 1) {
      navigateTo(
        '/audit?filter[needsAttention]=true&utm_source=hp&utm_medium=nac',
      );
    } else {
      const { id = '' } = audits?.at(0) ?? {};

      navigateTo(`/audit/${id}?utm_source=hp&utm_medium=nac`);
    }
  };

  useEffect(() => {
    if (!interactionCount) return;

    trackEvent(TrackHomePageEvent.NeedsAttentionCardMount, {
      numItem: interactionCount,
      eventTarget: 'compliance',
    });
  });

  return (
    <NeedsAttentionCard
      itemCount={interactionCount}
      color="error"
      headerStartAdornment={<Rule />}
      onClick={handleClick}
      supplementaryDetails={supplementaryDetails}
      title="Compliance Review Incomplete"
    />
  );
}

ComplianceReviewIncomplete.displayName = 'ComplianceReviewIncomplete';
